import { Language } from 'types/lang';

export const GTM_GLOBAL = 'GTM-KXXMPR';

export const GOOGLE_ANALYTICS_GLOBAL = 'G-GMY494ND5S';

export const GOOGLE_ANALYTICS = new Map<Language, string>([
  ['pl', 'G-ZR1DM3ZV30'],
  ['en', 'G-Z2EQCW5SBF'],
  ['es', 'G-BEBH7G5F5J'],
  ['de', 'G-94RXQ18G47'],
  ['fr', 'G-Y7N6HXMMFJ'],
  ['hu', 'G-6K1RNHV4SV'],
  ['it', 'G-JGB6ZZJDVR'],
  ['lt', 'G-2BDLKZBCNC'],
  ['ro', 'G-0BJDF7Q1G8'],
  ['ua', 'G-EQFS27L898'],
  ['ru', 'G-XCRXC95HGL'],
]);
